$(document).ready(function(){
  $(".b_header_bars, .b_header_cross").click(function(){
    $(".b_header_bars").toggleClass("b_header_bars_h");
    $(".b_header_cross").toggleClass("b_header_cross_h");
    $(".b_header_tab").toggleClass("b_header_tab_s");
    $("body").toggleClass("b_header_tab_body");
  });
  $(".b_header_cart_c").click(function(){
    $(".drawer").addClass("active");
    $("body").toggleClass("overflow-hidden");
  });
});

/* ==========================================================================
   LIVE CART COUNT
   The custom header draws its own count, so it only changed on a page load.
   Dawn re-renders its own (hidden) #cart-icon-bubble on every cart change,
   and publishes a cartUpdate event, so this watches both and mirrors the
   number into .b_header_cart_count, adding or removing the bubble as the
   cart fills and empties. Nothing here fetches on a normal page view.
   ========================================================================== */
(function () {
  if (window.__bHeaderCartCount) return;
  window.__bHeaderCartCount = true;

  function paint(count) {
    var wraps = document.querySelectorAll('.b_header_cart_bg');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      if (wrap.getAttribute('data-b-cart-count') === 'false') continue;
      var el = wrap.querySelector('.b_header_cart_count');
      if (!count || count < 1) {
        if (el && el.parentNode) el.parentNode.removeChild(el);
        continue;
      }
      if (!el) {
        el = document.createElement('span');
        el.className = 'b_header_cart_count';
        wrap.appendChild(el);
      }
      el.textContent = count > 99 ? '99+' : String(count);
    }
  }

  var fetching = false;
  function fromCartJson() {
    if (fetching) return;
    fetching = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { paint(cart.item_count); })
      .catch(function () {})
      .then(function () { fetching = false; });
  }

  // Dawn's own bubble, which Shopify re-renders on every cart change.
  function fromDawnBubble() {
    var dawn = document.getElementById('cart-icon-bubble');
    if (!dawn) return false;
    var bubble = dawn.querySelector('.cart-count-bubble');
    if (!bubble) {
      paint(0);
      return true;
    }
    var digits = bubble.querySelector('span[aria-hidden]');
    var n = digits ? parseInt(digits.textContent.trim(), 10) : NaN;
    if (isNaN(n)) {
      fromCartJson(); // 100+ items: Dawn prints no digits.
      return true;
    }
    paint(n);
    return true;
  }

  var dawnIcon = document.getElementById('cart-icon-bubble');
  if (dawnIcon && window.MutationObserver) {
    new MutationObserver(function () {
      fromDawnBubble();
    }).observe(dawnIcon, { childList: true, subtree: true, characterData: true });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var data = event && event.cartData;
      if (data && typeof data.item_count === 'number') {
        paint(data.item_count);
      } else {
        // An add to cart reports the line, not the cart, and Dawn has not
        // repainted its own bubble yet, so ask Shopify for the count.
        fromCartJson();
      }
    });
  }

  // Back from the browser cache with a cart that changed in another tab.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) fromCartJson();
  });
})();